import { h } from '@stencil/core';

export default function LockedVoiceChannel<T>(props: T) {
	return (
		<svg {...props} aria-hidden="false" width="24" height="24" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M17 11V7C17 4.243 14.756 2 12 2C9.242 2 7 4.243 7 7V11C5.897 11 5 11.896 5 13V20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V13C19 11.896 18.103 11 17 11ZM12 18C11.172 18 10.5 17.328 10.5 16.5C10.5 15.672 11.172 15 12 15C12.828 15 13.5 15.672 13.5 16.5C13.5 17.328 12.828 18 12 18ZM15 11H9V7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7V11Z"
				aria-hidden="true"
			/>
		</svg>
	);
}
